import { QueryClient } from 'react-query';

/** Un préfixe de clé (`startsWith`) ou un prédicat sur l'URL (première entrée de la clé). */
export type KeyMatcher = string | ((url: string) => boolean);

/** Invalide (et refetch si actives) les requêtes dont l'URL de clé correspond à l'un des matchers. */
export const invalidatePrefixes = (queryClient: QueryClient, ...matchers: KeyMatcher[]) =>
    queryClient.invalidateQueries({
        predicate: (query) =>
            Array.isArray(query.queryKey) &&
            typeof query.queryKey[0] === 'string' &&
            matchers.some((matcher) => {
                const url = query.queryKey[0] as string;
                return typeof matcher === 'string' ? url.startsWith(matcher) : matcher(url);
            }),
        refetchActive: true,
    });
